module.exports = __webpack_public_path__ + "img/image16.37ffb596.png";